"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var transform = exports.transform = {
  type: "select",
  options: [{ label: "Capitalize", value: "capitalize" }, { label: "Uppercase", value: "uppercase" }, { label: "Lowercase", value: "lowercase" }]
};

var position = exports.position = {
  type: "select",
  options: [{ label: "Left", value: "left" }, { label: "Center", value: "center" }, { label: "Right", value: "right" }]
};